import { TicketPriority } from '@/types/enums';

function getTicketPriority(priority: TicketPriority): string {
  if (priority === TicketPriority.High) return '加急工单';
  return '普通工单';
}

export default getTicketPriority;
